module.exports = __webpack_public_path__ + "static/media/warningBlue.ba97d8c4.svg";